import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    maxRetries: { type: Number, default: 3 },
    retryDelay: { type: Number, default: 1000 }, // 1 second
  };

  static targets = ["image"];

  connect() {
    // Temporarily disable
    return;
    this.retryCount = 0;
    this.originalSrc = this.imageTarget.src;
    this.setupImageErrorHandler();
  }

  setupImageErrorHandler() {
    this.imageTarget.addEventListener("error", () => {
      if (this.retryCount < this.maxRetriesValue) {
        this.retryCount++;
        setTimeout(() => {
          this.imageTarget.src = this.originalSrc;
        }, this.retryDelayValue);
      }
    });
  }
}
